// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DRaBC","rotation":"Loader_rotation__eK6nx"};